import { Epic, ofType } from 'redux-observable';
import { concat, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    SaveImportExportWizardSuccess,
    saveImportExportWizardSuccessAction
} from '../../actions/importExportWizard/saveImportExportWizardSuccess';
import {
    UpdateImportExportWizardLock,
    updateImportExportWizardLockAction
} from '../../actions/importExportWizard/updateImportExportWizardLock';
import {
    SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR,
    ShowUploadFileImportWizardRequestError
} from '../../actions/importWizard/showUploadFileImportWizardRequestError';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';

type EpicActions = SaveImportExportWizardSuccess | UpdateImportExportWizardLock;

export const showUploadFileImportWizardRequestErrorEpic: Epic<Action, Action, State, EpicDeps> = action$ => {
    return action$.pipe(
        ofType(SHOW_UPLOAD_FILE_IMPORT_WIZARD_REQUEST_ERROR),
        switchMap(
            (action: ShowUploadFileImportWizardRequestError): Observable<EpicActions> => {
                return concat(of(saveImportExportWizardSuccessAction()), of(updateImportExportWizardLockAction(false)));
            }
        )
    );
};
